import { cn } from '@/lib/utils';

import { SignalsSpinner } from './SignalsSpinner';

export const CURSOR_PLACEHOLDER = '\u200B';

interface Props {
  whitespace?: boolean;
}

/**
 * The "still writing" marker at the tail of a streaming answer.
 *
 * Was a pulsing dot drawn by `.loading-cursor`; it is now the Signals mark at
 * 16px. The `.loading-cursor` rule is left in index.css so tenant CSS that
 * targets it keeps resolving, but a tenant that customised the dot through the
 * --loading-cursor-* variables in theme.json will no longer see that
 * customisation take effect.
 */
export default function BlinkingCursor({ whitespace }: Props) {
  return (
    <SignalsSpinner
      size="sm"
      className={cn('align-middle', whitespace && 'ml-2')}
    />
  );
}
